import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class AuthApi {
	async logout(data = []) {
		try {
			const response = await axios.post(BASE_URI + '/v1/logout' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async register(data = []) {
		try {
			const response = await axios.post(BASE_URI + '/v1/auth/register' + signature(), data);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getProfile() {
		try {
			const response = await axios.get(BASE_URI + '/v1/profile' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateProfile(data = []) {
		try {
			const response = await axios.put(BASE_URI + '/v1/profile' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// เปลี่ยนรหัสผ่านอย่างเดียว — เส้นแยกจาก updateProfile ที่บังคับส่งฟอร์มโปรไฟล์ทั้งก้อน
	// (api/docs/password-reset.md §5.2)
	async changePassword(data = []) {
		try {
			const response = await axios.post(BASE_URI + '/v1/change-password' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Auth = new AuthApi();
